import { useStores } from 'common/hooks/useStores';
import EmptyTopNav from 'components/topNav/EmptyTopNav';
import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const Logout = () => {
    const { authStore } = useStores();

    useEffect(() => {
        authStore.removeAuthInfo();
    }, []);

    return (
        <div className="logout">
            <EmptyTopNav />
            <h1>You have been successfully logged out</h1>
            <div>
                <span className="u-text-secondary">
                    <Link to={'/login'} className="c-link c-link--primary">
                        Sign back in
                    </Link>
                </span>
            </div>
        </div>
    );
};

export default observer(Logout);
